import { axiosClient } from "./axiosClient";

export type DocumentType = "terms_of_service" | "privacy_policy" | "accessibility";

export type PlatformDocument = {
  type: DocumentType;
  title: string;
  version: number;
  content: string | null;
  requires_acceptance: boolean;
  file_url: string | null;
  updated_at: string;
};

export type PendingDocument = { type: DocumentType; title: string; version: number };

// Bieżące wersje dokumentów (regulamin / polityka / deklaracja) — publiczne, do osadzenia.
export const getCurrentDocuments = () => axiosClient.get<{ documents: PlatformDocument[] }>("documents/current");

// Dokumenty wymagające (ponownej) akceptacji przez zalogowanego użytkownika.
export const getPendingDocuments = () => axiosClient.get<{ documents: PlatformDocument[] }>("documents/pending");

// Zapis akceptacji bieżących wersji regulaminu i polityki.
export const acceptDocuments = () => axiosClient.post<{ accepted: boolean }>("documents/accept");
